// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__sbBDw","content":"Consent_content__2n-Hb","footer":"Consent_footer__2CKNQ"};